export default __webpack_public_path__ + "img/preview-icon.a6b126c6.svg";